export interface AnimeItem {
  id: number;
  title: string;
  coverImage: string;
  category: string;
  categorySlug: string;
  episodes: string;
  rating: number;
  year: number;
  description: string;
  studio: string;
  status: string;
  tags: string[];
  featured: boolean;
  popular: boolean;
  latest: boolean;
  updateDate: string;
}

export const animeList: AnimeItem[] = [
  {
    id: 1,
    title: "鬼灭之刃 无限列车篇",
    coverImage: "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20Demon%20Slayer%2C%20young%20warrior%20with%20katana%20sword%20in%20flame%20pattern%20kimono%2C%20dramatic%20fire%20background%20with%20dark%20tones%2C%20Japanese%20anime%20art%20style%2C%20high%20contrast%20shadows%2C%20cinematic%20lighting%2C%20rich%20warm%20colors&width=600&height=850&seq=anime-cover-01&orientation=portrait",
    category: "热血战斗",
    categorySlug: "action",
    episodes: "全7集",
    rating: 9.6,
    year: 2021,
    description: "在无限列车上，炭治郎与炎柱炼狱杏寿郎联手对抗下弦之壹魇梦，却遭遇了上弦之叁猗窝座的突袭。一场关乎生命与尊严的激烈战斗就此展开，炼狱杏寿郎以惊人的意志力和炎之呼吸守护着所有人的生命。",
    studio: "ufotable",
    status: "已完结",
    tags: ["热血", "战斗", "冒险", "少年"],
    featured: true,
    popular: true,
    latest: false,
    updateDate: "2021-09-25",
  },
  {
    id: 2,
    title: "咒术回战 第二季",
    coverImage: "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20Jujutsu%20Kaisen%2C%20white%20haired%20sorcerer%20with%20blindfold%20and%20black%20uniform%2C%20mystical%20cursed%20energy%20effects%20in%20dark%20purple%20and%20blue%2C%20modern%20urban%20Japanese%20anime%20art%20with%20dynamic%20pose%2C%20dramatic%20lighting&width=600&height=850&seq=anime-cover-02&orientation=portrait",
    category: "热血战斗",
    categorySlug: "action",
    episodes: "全23集",
    rating: 9.4,
    year: 2023,
    description: "故事回溯到五条悟与夏油杰的高专时代，揭示了两人从挚友走向对立的过程。与此同时，涉谷事变篇中咒术师与咒灵之间的全面战争爆发，各角色面临生死抉择。",
    studio: "MAPPA",
    status: "已完结",
    tags: ["热血", "战斗", "超能力", "校园"],
    featured: true,
    popular: true,
    latest: false,
    updateDate: "2023-12-28",
  },
  {
    id: 3,
    title: "间谍过家家 第二季",
    coverImage: "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20Spy%20x%20Family%2C%20elegant%20family%20of%20three%20with%20pink%20haired%20little%20girl%20holding%20stuffed%20toy%2C%20gentleman%20in%20suit%20and%20beautiful%20woman%2C%20warm%20comedy%20anime%20art%20style%2C%20soft%20pastel%20colors%2C%20cozy%20family%20atmosphere&width=600&height=850&seq=anime-cover-03&orientation=portrait",
    category: "搞笑日常",
    categorySlug: "comedy",
    episodes: "全12集",
    rating: 9.2,
    year: 2023,
    description: "间谍父亲、杀手母亲、读心术女儿——这个临时组建的家庭继续着他们各自隐藏身份的同居生活。阿尼亚的新学期开始了，更多有趣的日常和惊险的任务在这个家庭中展开。",
    studio: "WIT STUDIO x CloverWorks",
    status: "已完结",
    tags: ["搞笑", "日常", "家庭", "间谍"],
    featured: true,
    popular: true,
    latest: false,
    updateDate: "2023-12-24",
  },
  {
    id: 4,
    title: "葬送的芙莉莲",
    coverImage: "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20Frieren%2C%20elven%20mage%20girl%20with%20long%20silver%20hair%20and%20staff%20walking%20through%20flower%20field%2C%20fantasy%20adventure%20anime%20art%2C%20melancholic%20and%20beautiful%20atmosphere%2C%20soft%20golden%20sunset%20lighting%2C%20emotional%20journey%20theme&width=600&height=850&seq=anime-cover-04&orientation=portrait",
    category: "奇幻冒险",
    categorySlug: "fantasy",
    episodes: "全28集",
    rating: 9.5,
    year: 2024,
    description: "打败魔王后，勇者队伍中的精灵魔法使芙莉莲踏上了理解人类的旅程。她重新走过当年与勇者一行人的冒险之路，在回忆与现实中逐渐理解「时间」的意义和「感情」的真谛。",
    studio: "MADHOUSE",
    status: "已完结",
    tags: ["奇幻", "冒险", "治愈", "催泪"],
    featured: true,
    popular: true,
    latest: true,
    updateDate: "2024-03-22",
  },
  {
    id: 5,
    title: "夏日重现",
    coverImage: "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20Summer%20Time%20Rendering%2C%20boy%20and%20girl%20on%20beach%20at%20sunset%20with%20mysterious%20shadow%20looming%2C%20island%20setting%2C%20suspense%20thriller%20anime%20art%2C%20warm%20orange%20sunset%20colors%20with%20dark%20contrast%2C%20mysterious%20atmosphere&width=600&height=850&seq=anime-cover-05&orientation=portrait",
    category: "悬疑推理",
    categorySlug: "mystery",
    episodes: "全25集",
    rating: 9.1,
    year: 2022,
    description: "少年网代慎平回到故乡日都岛参加青梅竹马的葬礼，却发现岛上的「影子病」正在蔓延。他利用「轮回」能力不断回到过去，试图阻止悲剧的发生，揭开岛上隐藏的惊天秘密。",
    studio: "OLM",
    status: "已完结",
    tags: ["悬疑", "推理", "轮回", "惊悚"],
    featured: false,
    popular: true,
    latest: false,
    updateDate: "2022-09-30",
  },
  {
    id: 6,
    title: "进击的巨人 最终季 完结篇",
    coverImage: "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20Attack%20on%20Titan%20final%20season%2C%20soldier%20with%20cape%20facing%20colossal%20titan%20in%20destruction%2C%20apocalyptic%20scenery%2C%20dark%20and%20epic%20anime%20art%20with%20intense%20red%20and%20black%20tones%2C%20cinematic%20war%20atmosphere&width=600&height=850&seq=anime-cover-06&orientation=portrait",
    category: "热血战斗",
    categorySlug: "action",
    episodes: "完结篇前后篇",
    rating: 9.3,
    year: 2023,
    description: "艾伦发动地鸣，无数超大型巨人踏平大地，世界面临毁灭性危机。曾经的同伴们必须做出最终的选择——是阻止艾伦，还是任由他将一切毁灭。这部史诗级作品迎来了壮丽的终章。",
    studio: "MAPPA",
    status: "已完结",
    tags: ["热血", "战斗", "末世", "史诗"],
    featured: false,
    popular: true,
    latest: false,
    updateDate: "2023-11-05",
  },
  {
    id: 7,
    title: "我推的孩子",
    coverImage: "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20Oshi%20no%20Ko%2C%20beautiful%20idol%20girl%20with%20star%20eyes%20and%20long%20purple%20hair%20on%20stage%2C%20spotlight%20and%20glitter%20effects%2C%20entertainment%20industry%20themed%20anime%20art%2C%20glamorous%20yet%20mysterious%20atmosphere%2C%20vibrant%20stage%20lighting&width=600&height=850&seq=anime-cover-07&orientation=portrait",
    category: "恋爱治愈",
    categorySlug: "romance",
    episodes: "全11集",
    rating: 9.0,
    year: 2023,
    description: "妇产科医生吾郎意外转生为自己偶像星野爱的孩子。在演艺圈的华丽表面下，隐藏着不为人知的黑暗与真相。两个孩子在这个复杂的世界中追寻着自己的梦想与复仇。",
    studio: "动画工房",
    status: "已完结",
    tags: ["转生", "偶像", "悬疑", "娱乐圈"],
    featured: false,
    popular: true,
    latest: false,
    updateDate: "2023-06-28",
  },
  {
    id: 8,
    title: "药屋少女的呢喃",
    coverImage: "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20Apothecary%20Diaries%2C%20beautiful%20girl%20with%20freckles%20in%20ancient%20Chinese%20style%20palace%20dress%2C%20holding%20herbs%20and%20medicine%2C%20historical%20palace%20setting%20with%20elegant%20traditional%20aesthetics%2C%20mystery%20and%20romance%20anime%20art&width=600&height=850&seq=anime-cover-08&orientation=portrait",
    category: "悬疑推理",
    categorySlug: "mystery",
    episodes: "全24集",
    rating: 9.3,
    year: 2024,
    description: "在后宫当差的前药师少女猫猫，凭借丰富的医药知识和敏锐的观察力，在宫廷中解决各种疑难杂症和神秘事件。她与英俊的宦官壬氏之间的互动也让故事充满了趣味。",
    studio: "TOHO animation STUDIO x OLM",
    status: "已完结",
    tags: ["推理", "宫廷", "历史", "医疗"],
    featured: false,
    popular: true,
    latest: true,
    updateDate: "2024-03-24",
  },
  {
    id: 9,
    title: "迷宫饭",
    coverImage: "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20Delicious%20in%20Dungeon%2C%20adventurer%20party%20cooking%20monster%20food%20in%20dungeon%2C%20fantasy%20cooking%20comedy%20anime%20art%2C%20warm%20and%20appetizing%20food%20illustrations%20with%20dungeon%20background%2C%20cozy%20adventure%20atmosphere&width=600&height=850&seq=anime-cover-09&orientation=portrait",
    category: "搞笑日常",
    categorySlug: "comedy",
    episodes: "全24集",
    rating: 9.1,
    year: 2024,
    description: "在迷宫深处失去妹妹的冒险者莱欧斯，为了在迷宫中生存下去，决定一边打倒魔物一边将它们做成料理食用。一场关于美食与冒险的奇妙旅程就此展开。",
    studio: "TRIGGER",
    status: "已完结",
    tags: ["美食", "冒险", "搞笑", "奇幻"],
    featured: false,
    popular: false,
    latest: true,
    updateDate: "2024-06-13",
  },
  {
    id: 10,
    title: "摇曳露营△ 第三季",
    coverImage: "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20Yuru%20Camp%2C%20cute%20girls%20camping%20by%20lake%20with%20tent%20and%20campfire%20under%20starry%20night%2C%20Mount%20Fuji%20in%20background%2C%20healing%20slice%20of%20life%20anime%20art%2C%20peaceful%20and%20warm%20atmosphere%2C%20soft%20night%20lighting&width=600&height=850&seq=anime-cover-10&orientation=portrait",
    category: "日常治愈",
    categorySlug: "slice-of-life",
    episodes: "全12集",
    rating: 9.0,
    year: 2024,
    description: "寒冬过后，春天来临，各务原抚子和志摩凛再次踏上露营之旅。新的成员加入，新的露营地探索，温暖治愈的露营日常继续上演，带观众领略日本各地的自然风光。",
    studio: "8bit",
    status: "已完结",
    tags: ["治愈", "日常", "露营", "美食"],
    featured: false,
    popular: false,
    latest: true,
    updateDate: "2024-06-20",
  },
  {
    id: 11,
    title: "电锯人",
    coverImage: "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20Chainsaw%20Man%2C%20blond%20boy%20with%20chainsaw%20arms%20and%20head%20in%20urban%20city%2C%20blood%20splatter%20and%20action%20pose%2C%20dark%20gritty%20anime%20art%20style%2C%20neon%20city%20lights%20atmosphere%2C%20violent%20aesthetic&width=600&height=850&seq=anime-cover-11&orientation=portrait",
    category: "热血战斗",
    categorySlug: "action",
    episodes: "全12集",
    rating: 8.8,
    year: 2022,
    description: "背负着父亲巨额债务的少年淀治，在濒死时与恶魔波奇塔融合，获得了变身电锯人的能力。加入公安对魔特异4课后，他在与恶魔的战斗中逐渐发现隐藏在背后的巨大阴谋。",
    studio: "MAPPA",
    status: "已完结",
    tags: ["战斗", "黑暗", "恶魔", "都市"],
    featured: false,
    popular: false,
    latest: false,
    updateDate: "2022-12-27",
  },
  {
    id: 12,
    title: "辉夜大小姐想让我告白 第三季",
    coverImage: "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20Kaguya%20sama%20Love%20is%20War%2C%20elegant%20student%20council%20president%20and%20vice%20president%20facing%20each%20other%20romantically%2C%20romantic%20comedy%20anime%20art%2C%20school%20setting%20with%20cherry%20blossoms%2C%20soft%20pink%20and%20white%20color%20palette&width=600&height=850&seq=anime-cover-12&orientation=portrait",
    category: "恋爱治愈",
    categorySlug: "romance",
    episodes: "全13集",
    rating: 9.4,
    year: 2022,
    description: "在奉心祭的舞台上，白银御行与四宫辉夜这对傲娇天才终于要直面彼此的心意。超浪漫的告白大作战迎来最高潮，学生会的伙伴们也各自面临着感情的选择。",
    studio: "A-1 Pictures",
    status: "已完结",
    tags: ["恋爱", "搞笑", "校园", "日常"],
    featured: false,
    popular: false,
    latest: false,
    updateDate: "2022-06-25",
  },
  {
    id: 13,
    title: "不死少女・杀人笑剧",
    coverImage: "https://readdy.ai/api/search-image?width=600&height=850&seq=anime-cover-13&orientation=portrait&query=Anime%20style%20illustration%20of%20Undead%20Girl%20Murder%20Farce%2C%20woman%20detective%20with%20cage%20containing%20talking%20head%2C%20Victorian%20era%20setting%2C%20gothic%20mystery%20anime%20art%2C%20dark%20elegant%20atmosphere%20with%20candlelight%2C%19th%20century%20European%20aesthetic",
    category: "悬疑推理",
    categorySlug: "mystery",
    episodes: "全13集",
    rating: 8.7,
    year: 2023,
    description: "只有头颅存活的美丽少女侦探轮堂鸦夜，与被称为「鬼杀」的半人半妖真打津轻一起，在19世纪末的欧洲解决各种涉及怪物的离奇案件。哥特风的推理冒险就此展开。",
    studio: "Lapin Track",
    status: "已完结",
    tags: ["推理", "哥特", "怪物", "历史"],
    featured: false,
    popular: false,
    latest: false,
    updateDate: "2023-09-28",
  },
  {
    id: 14,
    title: "平家物语",
    coverImage: "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20Heike%20Monogatari%2C%20young%20girl%20with%20heterochromia%20eyes%20in%20Heian%20period%20kimono%2C%20Japanese%20historical%20drama%20anime%20art%2C%20elegant%20traditional%20aesthetic%20with%20falling%20cherry%20blossoms%2C%20poetic%20and%20melancholic%20atmosphere&width=600&height=850&seq=anime-cover-14&orientation=portrait",
    category: "奇幻冒险",
    categorySlug: "fantasy",
    episodes: "全11集",
    rating: 8.9,
    year: 2022,
    description: "拥有能看到未来之眼的少女琵琶，被平家重盛收留后，亲眼见证了平家一族从荣华走向灭亡的历史洪流。这部作品以诗意的视角描绘了日本平安时代末期的壮丽画卷。",
    studio: "Science SARU",
    status: "已完结",
    tags: ["历史", "奇幻", "战争", "文学"],
    featured: false,
    popular: false,
    latest: false,
    updateDate: "2022-01-20",
  },
  {
    id: 15,
    title: "孤独摇滚！",
    coverImage: "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20Bocchi%20the%20Rock%2C%20pink%20haired%20shy%20girl%20playing%20electric%20guitar%20on%20stage%2C%20band%20performance%20anime%20art%2C%20music%20themed%20with%20energetic%20lighting%2C%20cute%20and%20colorful%20art%20style%2C%20concert%20atmosphere&width=600&height=850&seq=anime-cover-15&orientation=portrait",
    category: "搞笑日常",
    categorySlug: "comedy",
    episodes: "全12集",
    rating: 9.3,
    year: 2022,
    description: "极度社恐的少女后藤一里，在机缘巧合下加入了一支女子摇滚乐队。从躲在壁橱里弹吉他的孤独者，到站上舞台绽放光芒的吉他手，这是一部关于音乐、友情与成长的青春物语。",
    studio: "CloverWorks",
    status: "已完结",
    tags: ["音乐", "搞笑", "青春", "乐队"],
    featured: false,
    popular: false,
    latest: false,
    updateDate: "2022-12-24",
  },
  {
    id: 16,
    title: "怪兽8号",
    coverImage: "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20Kaiju%20No%208%2C%20middle%20aged%20man%20transforming%20into%20monster%20with%20glowing%20blue%20cracks%2C%20sci%20fi%20action%20anime%20art%2C%20military%20setting%20with%20giant%20monsters%20in%20background%2C%20dynamic%20and%20powerful%20composition&width=600&height=850&seq=anime-cover-16&orientation=portrait",
    category: "热血战斗",
    categorySlug: "action",
    episodes: "全12集",
    rating: 8.6,
    year: 2024,
    description: "32岁的中年大叔日比野卡夫卡，在意外获得变身怪兽的能力后，立志加入日本防卫队对抗怪兽。以「怪兽8号」的身份，他在怪兽与人类之间书写着属于自己的英雄传说。",
    studio: "Production I.G",
    status: "已完结",
    tags: ["战斗", "科幻", "怪兽", "热血"],
    featured: false,
    popular: false,
    latest: true,
    updateDate: "2024-06-29",
  },
];

export const featuredAnime = animeList.filter((a) => a.featured);
export const popularAnime = animeList.filter((a) => a.popular);
export const latestAnime = animeList.filter((a) => a.latest);